import React, { useEffect, useState } from 'react';
import { useAppDispatch } from "../../../../utils/hooks";
import { useAuthContext } from '../../../authentication/contexts/AuthContext';
import { Box } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { acceptBeaconGroup, fetchError } from '../../../../redux/actions';
import { useNavigate } from 'react-router-dom';

const ShareGroupAccept = () => {

    const auth = useAuthContext();
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState<boolean>(false);


    useEffect(() => {
        setIsLoading(true);
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');

        if (code) {
            handleAcceptInvite(code);
        }
        else {
            dispatch(fetchError("No invitation code was found"));
            navigate("/beacons");
        }
        setIsLoading(false);
    }, []);


    const handleAcceptInvite = (code: string) => {
            dispatch(acceptBeaconGroup(code, (result: boolean, beacongroupid?: string) => {
                if (result) {
                  navigate("/beacons");
                }
                else {
                    navigate("/beacons");
                }
            })
        );
    };
    return (
        <Box sx={{ 
            display: "flex", 
            justifyContent: "center", 
            alignItems: "center", 
            minHeight: "100vh" 
        }}>
            {isLoading && (
                <CircularProgress />  
            )}
 
        </Box>
    );
};

export default ShareGroupAccept;
